// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Courses from './pages/Courses';
import CourseLanding from './pages/CourseLanding';
import LANDING_CONTENT from './components/courses/landingContent';
import AccessibilityStatement from './pages/AccessibilityStatement';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import AccessibilityToolbar from './components/AccessibilityToolbar';
import SkipToContent from './components/SkipToContent';

function App() {
  return (
    <Router basename="/">
      <SkipToContent />
      <AccessibilityToolbar />
      <NavBar />
      <main id="main-content" role="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/courses" element={<Courses />} />
          {/* One landing page per course — the destination for its ads. The
              paths live next to the copy so a new course adds a route by
              existing rather than by being remembered here. */}
          {Object.entries(LANDING_CONTENT).map(([id, { path }]) => (
            <Route key={id} path={path} element={<CourseLanding courseId={id} />} />
          ))}
          <Route path="/about" element={<About />} />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          {/* Catch all undefined routes and redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;